import React from 'react';
export function GuaranteeSection() {
  return <section className="w-full bg-bg-main py-16 sm:py-24 px-4" data-id="element-112">
      <div className="max-w-3xl mx-auto text-center" data-id="element-113">
        <div className="text-5xl sm:text-6xl mb-6" data-id="element-114">🛡️</div>

        <h2 className="text-2xl sm:text-4xl font-serif font-black text-text-main mb-6 uppercase" data-id="element-115">
          RECUPERA TU TIEMPO O TE DEVOLVEMOS EL DINERO
        </h2>

        <p className="text-text-sec text-base sm:text-lg leading-relaxed font-medium max-w-2xl mx-auto mb-8" data-id="element-116">
          7 días de garantía sin preguntas. Si no es lo que esperabas, te
          devolvemos el dinero. Escríbenos al email y listo.
        </p>

        <a href="#" className="text-primary font-medium text-sm hover:underline" data-id="element-117">
          Política de reembolso completa
        </a>
      </div>
    </section>;
}